export default {
  "HitPaw Online Audio Extractor": "HitPaw Online Ekstraktor Audio",
  "Extract sound from videos with ease.": "Ekstrak suara dari video dengan mudah.",
  "Select Audio Format": "Pilih Format Audio",
  "Extract Audio": "Ekstrak Audio",
  "Extracting Audio": "Mengekstrak Audio",
  "Extracted Successfully": "Berhasil Diekstrak",
  "Extract New": "Ekstrak Baru",
  "Extraction Failed": "Ekstraksi Gagal",
  "Format": "Format",
};
